"use client";

import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import {
  frontendServices,
  frontendHeroData,
  frontendStatsData,
  frontendFaqs,
  frontendSolutionsAndProcessData,
  frontendTechnologiesData,
  frontendAboutData,
  frontendPortfolioData,
} from "src/utils/mock/frontendAppData";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function FrontendAppDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const frontendProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const webApp = project.platforms?.toLowerCase().includes("web");

    const hasFrontendTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("frontend"));

    return isActive && webApp && hasFrontendTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: frontendProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={frontendHeroData} />
      <TechStats stats={frontendStatsData} />
      <NavigationSection data={frontendServices} />
      <WhyChooseUs data={frontendSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={frontendTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={frontendAboutData} mainTitle="About Our Frontend Development" />
        </div>
      </section>
      <FAQSection faqs={frontendFaqs} />
      <CommonContactSection />
    </div>
  );
}
